import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';

import { ReferenceBlock } from '../../components/reference-block';

export interface GoogleDriveReferenceNodeAttributes {
  url: string;
  content: string;
  date: string;
  'mime-type': string;
}

export const GoogleDriveReferenceNode = Node.create({
  name: 'google-driveReferenceNode',
  type: 'google-driveReferenceNode',
  group: 'block',
  atom: true,
  inline: false,
  selectable: false,
  draggable: true,

  parseHTML() {
    return [{ tag: 'google-drive-reference-node' }];
  },
  renderText({ node }) {
    return node.attrs.url;
  },
  renderHTML({ HTMLAttributes }) {
    return ['google-drive-reference-node', mergeAttributes(HTMLAttributes)];
  },
  addNodeView() {
    return ReactNodeViewRenderer((props) => <ReferenceBlock {...props} source="google_drive" />);
  },
  addAttributes() {
    return {
      url: {
        default: undefined,
      },
      content: {
        default: undefined,
      },
      name: {
        default: undefined,
      },
      date: {
        default: undefined,
      },
      'mime-type': {
        default: undefined,
      },
    };
  },
});
